<div class="login-page">
  <div class="container app-container">

    <div *ngIf="!requestRecuperarChaveAcesso" class="text-center">
      <i class="fa fa-spinner fa-pulse fa-4x"></i>
    </div>

    <div class="loginbox-v2 col-xs-12" *ngIf="requestRecuperarChaveAcesso">

      <div class="login-card">
        <h1 style="text-align: right; font-size: 3.5rem;">Recuperar <br class="visible-xs"> chave <br class="hidden-xs">
          de acesso</h1>
        <hr>
        <div class="login-card-list-icons">
          <img src="../../../assets/img/login/icon_loja.svg" alt="">
          <img src="../../../assets/img/login/icon_serviços.svg" alt="">
          <img src="../../../assets/img/login/Icon_contas.svg" alt="">
        </div>
      </div>
      <div class="text-left login-form">
        <div *ngIf="logotipo != undefined" class="app-logotipo-v2">
          <img src="{{ logotipo }}" alt="Logotipo">
        </div>
        <form (submit)="enviarEmailRecuperarChaveDeAcesso()" method="submit" ngNativeValidate
          #captchaProtectedForm="ngForm">
          <div>
            <div class="form-group">
              <div class="input-group" style="width: 100%">
                <label>Insira seu CPF/CNPJ:</label>
                <input [ngModel]="requestRecuperarChaveAcesso?.getDocumento()"
                  (ngModelChange)="requestRecuperarChaveAcesso?.setDocumento($event)" name="documento" type="text"
                  class="form-control" required>
              </div>
            </div>
            <div class="form-group">
              <div class="input-group" style="width: 100%; display: flex; justify-content: center;">
                <re-captcha class="g-recaptcha" [ngModel]="requestRecuperarChaveAcesso?.getRecaptchaChallenge()"
                  (ngModelChange)="requestRecuperarChaveAcesso?.setRecaptchaChallenge($event)" name="captcha"
                  [siteKey]="siteKey" required></re-captcha>
              </div>
            </div>
            <div class="col-xs-12 text-center">
              <button style="width: 100%;" [disabled]="!captchaProtectedForm.form.valid" class="btn btn-success-v2"
                type="submit">Recuperar
              </button> <br><br>
              <button style="width: 100%;" (click)="irParaLogin()" class="btn btn-danger-v2">Cancelar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/public/chave-de-acesso/chave-de-acesso.component.html